export const ShareButton = () => ({
  showMessage: false,
  message: '',

  share() {
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: window.location.href,
        })
        .catch((err) => {
          // 如果是使用者自己關閉分享介面，不會顯示message
          if (err.name === 'AbortError' || err.message.includes('cancel')) {
            return;
          }
          this.message = '分享失敗，請再試一次';
          this.showTemporaryMessage();
        });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.message = '已複製連結';
        this.showTemporaryMessage();
      });
    } else {
      this.message = '複製失敗，請手動複製連結';
      this.showTemporaryMessage();
    }
  },

  showTemporaryMessage() {
    this.showMessage = true;
    setTimeout(() => (this.showMessage = false), 1000);
  },
});
